module.exports = __webpack_public_path__ + "images/email/avatar-40-80e8816f09ccae5b0c60b02958b3f705.png";